module.exports = __webpack_public_path__ + "img/heart-circle.f739fb3f.svg";